import React, { useMemo } from 'react'
import "react-datetime/css/react-datetime.css";
import { ErrorMessage, FormikProps } from 'formik'
import { Attributes, Label, Validation } from 'app/modules/tp/builders/FormBuilder';
import DateRangeInput from './DatetimeRangeInput';
import { traverseArrayKeyObj, traverseKeyObj } from 'app/utils/keys';
import moment from 'moment';
import { Actions } from 'app/modules/tp/components/Modal/ModalEntity';

export type DateRangeInputObj<T> = {
    hoursRange?: boolean,
    dateRange?: boolean,
    type: "daterange" | "timerange",
    key: keyof T,
    placeholder?: string,
    isRequired?: boolean,
    attributes?: Attributes
} & Attributes & Validation & Label


export type DateRangeInputFieldProps<T> = {
    formik: FormikProps<T>,
    inputObj: DateRangeInputObj<T>
    actions: Actions<T>,
    onChange?: (e: T) => void,
}

const DateRangeInputField = <T,>({ formik, inputObj, onChange }: DateRangeInputFieldProps<T>) => {

    const isRequiredField = (inputObj: DateRangeInputObj<T>) => {
        return inputObj.validation?.spec?.presence === 'required'
    }

    const stateChange = (e: T) => {
        formik.setFieldValue(inputObj.key as string, e);
        onChange && onChange(e);
    }

    return (<>
        {inputObj.label && (
            <label className={`fw-bold fs-6 mb-2 ${isRequiredField(inputObj) ? "required" : ""} `}>
                {inputObj.label}
            </label>
        )}

        <DateRangeInput
            onChange={stateChange}
            type={inputObj.type}
            name={inputObj.key as string}
            value={formik.getFieldProps(inputObj.key as string)?.value}
            autoComplete='off'
            disabled={formik?.isSubmitting}
        />
        {formik?.touched[inputObj.key] && formik.errors[inputObj.key] && (
            <ErrorMessage name={inputObj.key as string}
                render={(error: string) => (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{error}</span>
                        </div>
                    </div>
                )} />
        )}

    </>
    )
}
export default DateRangeInputField;
